// Generated by scripts/align_chorales.ts. Do not edit by hand.
import type { ChoraleFile } from './types';
import c0 from './json/bwv269.json';
import c1 from './json/bwv347.json';
import c2 from './json/bwv153-1.json';
import c3 from './json/bwv86-6.json';
import c4 from './json/bwv267.json';
import c5 from './json/bwv281.json';
import c6 from './json/bwv17-7.json';
import c7 from './json/bwv40-8.json';
import c8 from './json/bwv248-12-2.json';
import c9 from './json/bwv38-6.json';
import c10 from './json/bwv65-2.json';
import c11 from './json/bwv33-6.json';
import c12 from './json/bwv184-5.json';
import c13 from './json/bwv277.json';
import c14 from './json/bwv311.json';
import c15 from './json/bwv145-5.json';
import c16 from './json/bwv318.json';
import c17 from './json/bwv351.json';
import c18 from './json/bwv302.json';
import c19 from './json/bwv153-5.json';
import c20 from './json/bwv180-7.json';
import c21 from './json/bwv28-6.json';
import c22 from './json/bwv415.json';
import c23 from './json/bwv148-6.json';
import c24 from './json/bwv20-11.json';
import c25 from './json/bwv308.json';
import c26 from './json/bwv36-8-2.json';
import c27 from './json/bwv32-6.json';
import c28 from './json/bwv363.json';
import c29 from './json/bwv256.json';
import c30 from './json/bwv386.json';
import c31 from './json/bwv330.json';
import c32 from './json/bwv305.json';
import c33 from './json/bwv248-53-5.json';
import c34 from './json/bwv385.json';
import c35 from './json/bwv352.json';
import c36 from './json/bwv115-6.json';
import c37 from './json/bwv259.json';
import c38 from './json/bwv255.json';
import c39 from './json/bwv65-7.json';
import c40 from './json/bwv67-7.json';
import c41 from './json/bwv377.json';
import c42 from './json/bwv108-6.json';
import c43 from './json/bwv248-9-s.json';
import c44 from './json/bwv416.json';
import c45 from './json/bwv26-6.json';
import c46 from './json/bwv382.json';
import c47 from './json/bwv244-37.json';
import c48 from './json/bwv91-6.json';
import c49 from './json/bwv429.json';
import c50 from './json/bwv122-6.json';
import c51 from './json/bwv151-5.json';
import c52 from './json/bwv110-7.json';
import c53 from './json/bwv121-6.json';
import c54 from './json/bwv404.json';
import c55 from './json/bwv174-5.json';
import c56 from './json/bwv245-3.json';
import c57 from './json/bwv133-6.json';
import c58 from './json/bwv159-5.json';
import c59 from './json/bwv197-10.json';
import c60 from './json/bwv245-11.json';
import c61 from './json/bwv194-6.json';
import c62 from './json/bwv144-3.json';
import c63 from './json/bwv280.json';
import c64 from './json/bwv39-7.json';
import c65 from './json/bwv431.json';
import c66 from './json/bwv226-2.json';
import c67 from './json/bwv322.json';
import c68 from './json/bwv177-5.json';
import c69 from './json/bwv6-6.json';
import c70 from './json/bwv334.json';
import c71 from './json/bwv244-54.json';
import c72 from './json/bwv291.json';
import c73 from './json/bwv30-6.json';
import c74 from './json/bwv248-46-5.json';
import c75 from './json/bwv244-3.json';
import c76 from './json/bwv342.json';
import c77 from './json/bwv244-44.json';
import c78 from './json/bwv245-15.json';
import c79 from './json/bwv46-6.json';
import c80 from './json/bwv245-14.json';
import c81 from './json/bwv197-5.json';
import c82 from './json/bwv45-7.json';
import c83 from './json/bwv36-4-2.json';
import c84 from './json/bwv56-5.json';
import c85 from './json/bwv244-62.json';
import c86 from './json/bwv57-8.json';
import c87 from './json/bwv42-7.json';
import c88 from './json/bwv168-6.json';
import c89 from './json/bwv194-12.json';
import c90 from './json/bwv47-5.json';
import c91 from './json/bwv55-5.json';
import c92 from './json/bwv87-7.json';
import c93 from './json/bwv169-7.json';
import c94 from './json/bwv244-15.json';
import c95 from './json/bwv16-6.json';
import c96 from './json/bwv18-5-w.json';
import c97 from './json/bwv164-6.json';
import c98 from './json/bwv43-11.json';
import c99 from './json/bwv13-6.json';
import c100 from './json/bwv88-7.json';
import c101 from './json/bwv244-46.json';
import c102 from './json/bwv245-28.json';
import c103 from './json/bwv245-40.json';
import c104 from './json/bwv245-26.json';
import c105 from './json/bwv187-7.json';
import c106 from './json/bwv102-7.json';
import c107 from './json/bwv245-17.json';
import c108 from './json/bwv84-5.json';
import c109 from './json/bwv245-37.json';
import c110 from './json/bwv419.json';
import c111 from './json/bwv244-25.json';
import c112 from './json/bwv29-8.json';
import c113 from './json/bwv244-10.json';
import c114 from './json/bwv244-32.json';
import c115 from './json/bwv176-6.json';
import c116 from './json/bwv103-6.json';
import c117 from './json/bwv85-6.json';
import c118 from './json/bwv183-5.json';
import c119 from './json/bwv268.json';
import c120 from './json/bwv104-6.json';
import c121 from './json/bwv18-5-lz.json';
import c122 from './json/bwv298.json';
import c123 from './json/bwv263.json';
import c124 from './json/bwv369.json';
import c125 from './json/bwv324.json';
import c126 from './json/bwv373.json';
import c127 from './json/bwv371.json';
import c128 from './json/bwv437.json';
import c129 from './json/bwv301.json';
import c130 from './json/bwv317.json';
import c131 from './json/bwv332.json';
import c132 from './json/bwv433.json';
import c133 from './json/bwv64-8.json';
import c134 from './json/bwv248-33-3.json';
import c135 from './json/bwv367.json';
import c136 from './json/bwv409.json';
import c137 from './json/bwv40-6.json';
import c138 from './json/bwv368.json';
import c139 from './json/bwv339.json';
import c140 from './json/bwv420.json';
import c141 from './json/bwv434.json';
import c142 from './json/bwv427.json';
import c143 from './json/bwv414.json';
import c144 from './json/bwv27-6.json';
import c145 from './json/bwv379.json';
import c146 from './json/bwv154-8.json';
import c147 from './json/bwv262.json';
import c148 from './json/bwv293.json';
import c149 from './json/bwv344.json';
import c150 from './json/bwv3-6.json';
import c151 from './json/bwv438.json';
import c152 from './json/bwv294.json';
import c153 from './json/bwv264.json';
import c154 from './json/bwv64-2.json';
import c155 from './json/bwv366.json';
import c156 from './json/bwv288.json';
import c157 from './json/bwv313.json';
import c158 from './json/bwv326.json';
import c159 from './json/bwv401.json';
import c160 from './json/bwv309.json';
import c161 from './json/bwv300.json';
import c162 from './json/bwv341.json';
import c163 from './json/bwv355.json';
import c164 from './json/bwv408.json';
import c165 from './json/bwv410.json';
import c166 from './json/bwv400.json';
import c167 from './json/bwv364.json';
import c168 from './json/bwv365.json';
import c169 from './json/bwv306.json';
import c170 from './json/bwv253.json';
import c171 from './json/bwv265.json';
import c172 from './json/bwv319.json';
import c173 from './json/bwv14-5.json';
import c174 from './json/bwv388.json';
import c175 from './json/bwv4-8.json';
import c176 from './json/bwv387.json';
import c177 from './json/bwv254.json';
import c178 from './json/bwv370.json';
import c179 from './json/bwv349.json';
import c180 from './json/bwv336.json';
import c181 from './json/bwv337.json';
import c182 from './json/bwv73-5.json';
import c183 from './json/bwv321.json';
import c184 from './json/bwv424.json';
import c185 from './json/bwv123-6.json';
import c186 from './json/bwv285.json';
import c187 from './json/bwv283.json';
import c188 from './json/bwv343.json';
import c189 from './json/bwv284.json';
import c190 from './json/bwv402.json';
import c191 from './json/bwv407.json';
import c192 from './json/bwv403.json';
import c193 from './json/bwv166-6.json';
import c194 from './json/bwv328.json';
import c195 from './json/bwv412.json';
import c196 from './json/bwv295.json';
import c197 from './json/bwv266.json';
import c198 from './json/bwv299.json';
import c199 from './json/bwv275.json';
import c200 from './json/bwv426.json';
import c201 from './json/bwv329.json';
import c202 from './json/bwv405.json';
import c203 from './json/bwv383.json';
import c204 from './json/bwv126-6.json';
import c205 from './json/bwv60-5.json';
import c206 from './json/bwv153-9.json';
import c207 from './json/bwv372.json';
import c208 from './json/bwv406.json';
import c209 from './json/bwv413.json';
import c210 from './json/bwv338.json';
import c211 from './json/bwv391.json';
import c212 from './json/bwv346.json';
import c213 from './json/bwv290.json';
import c214 from './json/bwv316.json';
import c215 from './json/bwv333.json';
import c216 from './json/bwv374.json';
import c217 from './json/bwv286.json';
import c218 from './json/bwv350.json';
import c219 from './json/bwv273.json';
import c220 from './json/bwv296.json';
import c221 from './json/bwv297.json';
import c222 from './json/bwv154-3.json';
import c223 from './json/bwv320.json';
import c224 from './json/bwv325.json';
import c225 from './json/bwv335.json';
import c226 from './json/bwv423.json';
import c227 from './json/bwv310.json';
import c228 from './json/bwv292.json';
import c229 from './json/bwv396.json';
import c230 from './json/bwv425.json';
import c231 from './json/bwv435.json';
import c232 from './json/bwv356.json';
import c233 from './json/bwv357.json';
import c234 from './json/bwv411.json';
import c235 from './json/bwv432.json';
import c236 from './json/bwv117-4.json';
import c237 from './json/bwv260.json';
import c238 from './json/bwv303.json';
import c239 from './json/bwv345.json';
import c240 from './json/bwv362.json';
import c241 from './json/bwv77-6.json';
import c242 from './json/bwv25-6.json';
import c243 from './json/bwv64-4.json';
import c244 from './json/bwv378.json';
import c245 from './json/bwv307.json';
import c246 from './json/bwv279.json';
import c247 from './json/bwv2-6.json';
import c248 from './json/bwv227-11.json';
import c249 from './json/bwv361.json';
import c250 from './json/bwv144-6.json';
import c251 from './json/bwv48-7.json';
import c252 from './json/bwv90-5.json';
import c253 from './json/bwv389.json';
import c254 from './json/bwv353.json';
import c255 from './json/bwv161-6.json';
import c256 from './json/bwv315.json';
import c257 from './json/bwv80-8.json';
import c258 from './json/bwv397.json';
import c259 from './json/bwv393.json';
import c260 from './json/bwv375.json';
import c261 from './json/bwv340.json';
import c262 from './json/bwv436.json';
import c263 from './json/bwv89-6.json';
import c264 from './json/bwv227-7.json';
import c265 from './json/bwv127-5.json';
import c266 from './json/bwv257.json';
import c267 from './json/bwv270.json';
import c268 from './json/bwv331.json';
import c269 from './json/bwv314.json';
import c270 from './json/bwv392.json';
import c271 from './json/bwv9-7.json';
import c272 from './json/bwv94-8.json';
import c273 from './json/bwv101-7.json';
import c274 from './json/bwv69-6-a.json';
import c275 from './json/bwv390.json';
import c276 from './json/bwv78-7.json';
import c277 from './json/bwv19-7.json';
import c278 from './json/bwv380.json';
import c279 from './json/bwv421.json';
import c280 from './json/bwv114-7.json';
import c281 from './json/bwv96-6.json';
import c282 from './json/bwv5-7.json';
import c283 from './json/bwv245-22.json';
import c284 from './json/bwv287.json';
import c285 from './json/bwv398.json';
import c286 from './json/bwv112-5.json';
import c287 from './json/bwv289.json';
import c288 from './json/bwv399.json';
import c289 from './json/bwv282.json';
import c290 from './json/bwv156-6.json';
import c291 from './json/bwv323.json';
import c292 from './json/bwv40-3.json';
import c293 from './json/bwv428.json';
import c294 from './json/bwv172-6.json';
import c295 from './json/bwv81-7.json';
import c296 from './json/bwv83-5.json';
import c297 from './json/bwv251.json';
import c298 from './json/bwv252.json';
import c299 from './json/bwv136-6.json';
import c300 from './json/bwv418.json';
import c301 from './json/bwv69-6.json';
import c302 from './json/bwv327.json';
import c303 from './json/bwv155-5.json';
import c304 from './json/bwv258.json';
import c305 from './json/bwv24-6.json';
import c306 from './json/bwv145-a.json';
import c307 from './json/bwv179-6.json';
import c308 from './json/bwv272.json';
import c309 from './json/bwv37-6.json';
import c310 from './json/bwv376.json';
import c311 from './json/bwv11-6.json';
import c312 from './json/bwv248-5.json';
import c313 from './json/bwv381.json';
import c314 from './json/bwv250.json';
import c315 from './json/bwv70-11.json';
import c316 from './json/bwv360.json';
import c317 from './json/bwv430.json';
import c318 from './json/bwv312.json';
import c319 from './json/bwv44-7.json';
import c320 from './json/bwv358.json';
import c321 from './json/bwv422.json';
import c322 from './json/bwv10-7.json';
import c323 from './json/bwv261.json';
import c324 from './json/bwv248-35-3.json';
import c325 from './json/bwv248-59-6.json';
import c326 from './json/bwv395.json';
import c327 from './json/bwv417.json';
import c328 from './json/bwv359.json';
import c329 from './json/bwv394.json';
import c330 from './json/bwv271.json';
import c331 from './json/bwv248-42-s.json';
import c332 from './json/bwv354.json';
import c333 from './json/bwv74-8.json';
import c334 from './json/bwv278.json';

/** Chorales that passed the alignment gate, in Riemenschneider order (compact; decode with codec.ts). */
export const CHORALE_FILES = [c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11, c12, c13, c14, c15, c16, c17, c18, c19, c20, c21, c22, c23, c24, c25, c26, c27, c28, c29, c30, c31, c32, c33, c34, c35, c36, c37, c38, c39, c40, c41, c42, c43, c44, c45, c46, c47, c48, c49, c50, c51, c52, c53, c54, c55, c56, c57, c58, c59, c60, c61, c62, c63, c64, c65, c66, c67, c68, c69, c70, c71, c72, c73, c74, c75, c76, c77, c78, c79, c80, c81, c82, c83, c84, c85, c86, c87, c88, c89, c90, c91, c92, c93, c94, c95, c96, c97, c98, c99, c100, c101, c102, c103, c104, c105, c106, c107, c108, c109, c110, c111, c112, c113, c114, c115, c116, c117, c118, c119, c120, c121, c122, c123, c124, c125, c126, c127, c128, c129, c130, c131, c132, c133, c134, c135, c136, c137, c138, c139, c140, c141, c142, c143, c144, c145, c146, c147, c148, c149, c150, c151, c152, c153, c154, c155, c156, c157, c158, c159, c160, c161, c162, c163, c164, c165, c166, c167, c168, c169, c170, c171, c172, c173, c174, c175, c176, c177, c178, c179, c180, c181, c182, c183, c184, c185, c186, c187, c188, c189, c190, c191, c192, c193, c194, c195, c196, c197, c198, c199, c200, c201, c202, c203, c204, c205, c206, c207, c208, c209, c210, c211, c212, c213, c214, c215, c216, c217, c218, c219, c220, c221, c222, c223, c224, c225, c226, c227, c228, c229, c230, c231, c232, c233, c234, c235, c236, c237, c238, c239, c240, c241, c242, c243, c244, c245, c246, c247, c248, c249, c250, c251, c252, c253, c254, c255, c256, c257, c258, c259, c260, c261, c262, c263, c264, c265, c266, c267, c268, c269, c270, c271, c272, c273, c274, c275, c276, c277, c278, c279, c280, c281, c282, c283, c284, c285, c286, c287, c288, c289, c290, c291, c292, c293, c294, c295, c296, c297, c298, c299, c300, c301, c302, c303, c304, c305, c306, c307, c308, c309, c310, c311, c312, c313, c314, c315, c316, c317, c318, c319, c320, c321, c322, c323, c324, c325, c326, c327, c328, c329, c330, c331, c332, c333, c334] as unknown as ChoraleFile[];
